/**
 * Entrada da aplicação.
 *
 * Substitui o bootstrap de `app/index.html`, que carregava React por CDN e
 * transpilava JSX no navegador com Babel. Aqui o build é do Vite e cada módulo
 * declara o que importa — o escopo global compartilhado deixa de existir.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '../styles.css';
import '../ui_kits/motion.css';
import { App } from './App';
import { criarRoteador } from './router/router';
import { inicializarSessao } from './session/sessao';

const raiz = document.getElementById('root');

if (!raiz) {
    throw new Error('#root não existe no index.html — a aplicação não tem onde montar.');
}

/* A sessão é lida ANTES de o roteador existir. `createBrowserRouter` dispara o
   loader da URL atual na CRIAÇÃO, e as guardas leem a sessão de forma síncrona:
   criar antes de recuperá-la manda para /entrar quem já estava logado — o F5 e
   o link fundo passam a deslogar. Por isso o roteador nasce aqui dentro, e não
   no topo de um módulo que o import avalia antes desta linha rodar.
   Sem `await` de topo, que o alvo do build (Safari 14) não aceita. */
void inicializarSessao().finally(() => {
    createRoot(raiz).render(
        <StrictMode>
            <App roteador={criarRoteador()} />
        </StrictMode>
    );
});
